console.log("appts loaded");

/// <reference types="jquery" />

import Headroom from "headroom.js";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "./../../Components/Header/Header";
import "./gtm";

document.addEventListener("DOMContentLoaded", function () {
  /**
   *
   *  sticky header
   *
   * */
  if (!document.querySelector("body.elementor-editor-active")) {
    let myElement = document.querySelector("header");
    let headroom = new Headroom(myElement, {
      offset: 20,
    });

    // initialise
    headroom.init();
  }

  /**
   *
   *  Tooltips
   *
   * */
  //preventDefault on [data-tippy] links
  document.querySelectorAll("[data-tippy] a").forEach((el) => {
    el.addEventListener("click", (e) => {
      e.preventDefault();
    });
  });

  tippy("[data-tippy]", {
    content(reference) {
      console.log("reference", reference);
      const template = reference.querySelector("[data-tippy-content]");
      return template.innerHTML;
    },
    trigger: "click",

    theme: "light",
    allowHTML: true,
  });

  /**
   *
   *  grav forms
   *
   * */
  var inputs = document.querySelectorAll(".gfield input");

  inputs.forEach(function (input) {
    input.addEventListener("focusout", function () {
      if (this.value != "") {
        this.classList.add("has-content");
      } else {
        this.classList.remove("has-content");
      }
    });
  });
});
